import type { IMessageWriter } from '../../../engine/messageWriter'
import { l } from '../../../lib/imports'
import { common } from '../../../main/common-sidecar'
import { chessCamera } from '../chessCamera-sidecar'
import { chessGameManager } from '../chessGameManager-sidecar'
import { chessGameMode_game } from '../chessGameMode_game-sidecar'
import { chessGameRules } from '../chessGameRules-sidecar'
import { EChessTeam } from '../chessPieces'
import { chessPieces } from '../chessPieces-sidecar'
import { chessTestParams } from '../chessTestParams-sidecar'
import { chessUiMessage } from '../ui/chessUiMessage-sidecar'
import { chessUiMultiplayerCursors } from '../ui/chessUiMultiplayerCursors-sidecar'
import { EChessClientRequest } from './chessMessageClientRequest'
import { chessMessageClientRequest } from './chessMessageClientRequest-sidecar'
import { chessMessageClientRequestResponse } from './chessMessageClientRequestResponse-sidecar'
import { chessMessageCursor } from './chessMessageCursor-sidecar'
import { EChessHostCommand } from './chessMessageHostCommand'
import { chessMessageHostCommand } from './chessMessageHostCommand-sidecar'
import { chessMessagePieceCreate } from './chessMessagePieceCreate-sidecar'
import { chessMessages } from './chessMessages-sidecar'
import { getIsHost } from './chessWebsockets'
import { chessWebsockets } from './chessWebsockets-sidecar'

//TODO: move these to extension file and add bulk of this file to engine
export function extension_getLocalServerAddress() {
  return 'ws://localhost:8901' // TODO: new chess server
}
export function extension_getRemoteServerAddress() {
  // return 'wss://ws-voyage.keepflyinggames.com' // TODO: new chess server
  return 'wss://ws-chess.keepflyinggames.com'
}
export function extension_onMeJoin() {
  chessGameManager.goGame()
  if (getIsHost()) {
    console.log('!! I am host RESET WORLD')
    chessMessageHostCommand.sendMessageAndImmediatelyExecute({
      command: EChessHostCommand.Reset,
    })
  }

  if (chessTestParams.multiplayerAutoSit) {
    if (chessWebsockets.getIsHost()) {
      chessMessageClientRequestResponse.sendMessageAndImmediatelyExecute({
        command: EChessClientRequest.SitWhite,
        multiId: chessWebsockets.getMultiId(),
      })
    } else {
      if (chessWebsockets.getMultiName() === 'bob') {
        chessMessageClientRequest.sendMessageRequest({
          command: EChessClientRequest.SitBlack,
          multiId: chessWebsockets.getMultiId(),
        })
      }
    }
  }
}
export function extension_onOtherJoin(multiId: number, name: string) {
  let cur = chessUiMultiplayerCursors.findByMultiIdSafe(multiId)
  chessUiMultiplayerCursors.setName(cur, name)

  if (getIsHost()) {
    // Auto sit joined player
    let white = chessGameManager.getPlayer(EChessTeam.White)
    let black = chessGameManager.getPlayer(EChessTeam.Black)
    if (!white.isEmpty && black.isEmpty) {
      chessMessageClientRequestResponse.sendMessageAndImmediatelyExecute({
        command: EChessClientRequest.SitBlack,
        multiId: multiId,
      })
    }
    if (white.isEmpty && !black.isEmpty) {
      chessMessageClientRequestResponse.sendMessageAndImmediatelyExecute({
        command: EChessClientRequest.SitWhite,
        multiId: multiId,
      })
    }
  }
}

export function extension_onOtherLeave(multiId: number) {
  let cur = chessUiMultiplayerCursors.findByMultiIdSafe(multiId)
  if (cur) {
    chessUiMultiplayerCursors.kill(cur)
  }
}

let _updateTimer = 0
let _updateTime = chessUiMultiplayerCursors.mouseCursorUpdateTime
let _lastMou = { x: 0, y: 0 }

export function extension_onUpdate() {
  let dt = common.getUpdateDelta()
  _updateTimer += dt
  if (_updateTimer > _updateTime) {
    _updateTimer = 0
    let mou = chessCamera.getAdjustedMousePosition()
    if (mou.x !== _lastMou.x && mou.y !== _lastMou.y) {
      chessMessageCursor.sendMessageToOthers({
        // multiId: _multiId,
        x: mou.x,
        y: mou.y,
      })
    }
    _lastMou = mou
  }
}

export function extension_sendWorldState(multiId: number) {
  if (getIsHost()) {
    console.log('!! Send world state', multiId)

    chessMessageHostCommand.sendMessageWorldState(
      {
        command: EChessHostCommand.Reset,
      },
      multiId,
    )

    l.forEach(chessPieces.getAll(), (c) => {
      chessMessagePieceCreate.sendMessageWorldState(
        {
          energy: c.energy,
          pieceId: c.id,
          team: c.team,
          type: c.type,
          i: c.i,
          j: c.j,
        },
        multiId,
      )
    })

    // Set seats
    let white = chessGameManager.getPlayer(EChessTeam.White)
    if (!white.isEmpty) {
      chessMessageClientRequestResponse.sendMessageWorldState(
        {
          command: EChessClientRequest.SitWhite,
          multiId: white.multiId,
        },
        multiId,
      )
    }

    let black = chessGameManager.getPlayer(EChessTeam.Black)
    if (!black.isEmpty) {
      chessMessageClientRequestResponse.sendMessageWorldState(
        {
          command: EChessClientRequest.SitBlack,
          multiId: black.multiId,
        },
        multiId,
      )
    }
    chessMessageHostCommand.sendMessageWorldState(
      {
        command: EChessHostCommand.Message,
        message: '',
      },
      multiId,
    )

    chessMessageHostCommand.sendMessageWorldState(
      {
        command: EChessHostCommand.Handicap,
        handicap: chessGameManager.get().handicap,
      },
      multiId,
    )
    chessMessageHostCommand.sendMessageWorldState(
      {
        command: EChessHostCommand.MoveTime,
        moveTime: chessGameRules.get().moveTime,
      },
      multiId,
    )
    if (chessGameMode_game.getIsGameStarted()) {
      chessMessageHostCommand.sendMessageWorldState(
        {
          command: EChessHostCommand.GameStart,
        },
        multiId,
      )
    }
  }
}

export function extension_process(m: IMessageWriter, skipFrom: boolean) {
  chessMessages.process(m, skipFrom)
}

export function extension_onVersionFail(
  serverVersion: string,
  yourVersion: string,
) {
  chessUiMessage.setText(
    'A new version is available!',
    'Please download the latest version ' + serverVersion + ' to continue.',
  )
  chessUiMessage.setOpen(true, () => {
    window.open(
      'https://www.keepflyinggames.com/games/until-your-king-is-dead/latest-version',
    )
  })
}
